import { MediaPreviewContainer } from "./MediaPreviewContainer";
import { MediaPreviewDownloadButton } from "./MediaPreviewDownloadButton";
import { MediaPreviewError } from "./MediaPreviewError";
import { MediaPreviewImage } from "./MediaPreviewImage";
import { MediaPreviewLoader } from "./MediaPreviewLoader";
import { MediaPreviewProvider } from "./MediaPreviewProvider";
import { MediaPreviewVideo } from "./MediaPreviewVideo";

/* eslint-disable @typescript-eslint/naming-convention */
export const MediaPreview = {
    Provider: MediaPreviewProvider,
    Container: MediaPreviewContainer,
    Loader: MediaPreviewLoader,
    Error: MediaPreviewError,
    DownloadButton: MediaPreviewDownloadButton,
    Image: MediaPreviewImage,
    Video: MediaPreviewVideo,
};
/* eslint-enable @typescript-eslint/naming-convention */
